module.exports = __webpack_public_path__ + "static/img/069_TO8_1692.33ca52d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/069_TO8_1692.jpg
// module id = mJa8
// module chunks = 0